module.exports = __webpack_public_path__ + "static/media/Articles 1.c4a1aa88.svg";